import { c as _c } from "react/compiler-runtime";
import { numberWithCommas } from "@/helpers/Helpers";
import type { LabNFT, NFT } from "@/entities/INFT";
import type { ReactNode } from "react";
import { MetadataLink } from "./MetadataLink";
export function NftPageStats(props) {
  const $ = _c(23);
  const hasHodlRate = !props.hide_hodl_rate && "hodl_rate" in props.nft;
  let t0;
  if ($[0] !== props.hide_mint_price || $[1] !== props.nft.mint_price) {
    t0 = !props.hide_mint_price && <NftStatTableRow label="Mint Price" value={props.nft.mint_price} decimals={100000} unit="ETH" />;
    $[0] = props.hide_mint_price;
    $[1] = props.nft.mint_price;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.hide_metadata || $[4] !== props.nft.uri) {
    t1 = !props.hide_metadata && <MetadataLink url={props.nft.uri} />;
    $[3] = props.hide_metadata;
    $[4] = props.nft.uri;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== hasHodlRate || $[7] !== props.nft.hodl_rate) {
    t2 = hasHodlRate && <NftStatTableRow label="TDH Rate" value={props.nft.hodl_rate} decimals={100} />;
    $[6] = hasHodlRate;
    $[7] = props.nft.hodl_rate;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== props.nft.floor_price) {
    t3 = <NftStatTableRow label="Floor Price" value={props.nft.floor_price} unit="ETH" />;
    $[9] = props.nft.floor_price;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== props.nft.market_cap) {
    t4 = <NftStatTableRow label="Market Cap" value={props.nft.market_cap} decimals={100} unit="ETH" />;
    $[11] = props.nft.market_cap;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== props.nft.highest_offer) {
    t5 = <NftStatTableRow label="Highest Offer" value={props.nft.highest_offer} unit="ETH" />;
    $[13] = props.nft.highest_offer;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== props.afterMetadata || $[16] !== t0 || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <>{t0}{t1}{props.afterMetadata}{t2}{t3}{t4}{t5}</>;
    $[15] = props.afterMetadata;
    $[16] = t0;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}
function NftStatTableRow(props) {
  const $ = _c(10);
  const decimals = props.decimals ?? 1000;
  const value = Math.round(props.value * decimals) / decimals;
  let t0;
  if ($[0] !== props.label) {
    t0 = <td>{props.label}</td>;
    $[0] = props.label;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.unit || $[3] !== value) {
    t1 = value > 0 ? `${numberWithCommas(value)} ${props.unit ?? ""}` : "N/A";
    $[2] = props.unit;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <td><span className="tw-font-medium">{t1}</span></td>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t0 || $[8] !== t2) {
    t3 = <tr>{t0}{t2}</tr>;
    $[7] = t0;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}